import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewShareIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="new-share-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.16812 11.7724C0.990849 11.5906 0.949363 11.3178 1.06473 11.0925L1.62593 9.99659C2.95414 7.40283 5.6445 5.76799 8.58466 5.76799H8.86058C8.8807 5.33577 8.90668 4.90374 8.9385 4.47204L8.99278 3.73584C9.03691 3.13715 9.71201 2.80248 10.2236 3.12569C11.9017 4.186 13.3606 5.55224 14.5224 7.15158L14.8873 7.65386C15.0376 7.8607 15.0376 8.1393 14.8873 8.34614L14.5224 8.84842C13.3606 10.4478 11.9017 11.814 10.2236 12.8743C9.71201 13.1975 9.03691 12.8628 8.99277 12.2642L8.9385 11.528C8.9005 11.0124 8.87083 10.4964 8.84951 9.98015C7.12965 9.93105 5.41189 10.2743 3.8332 10.9948L1.85145 11.8992C1.61958 12.005 1.34538 11.9541 1.16812 11.7724ZM2.94271 10.0943L3.33033 9.91741C5.25924 9.0371 7.37566 8.66544 9.47576 8.82494C9.7816 8.84817 10.0205 9.09577 10.0295 9.39896C10.0499 10.0804 10.0852 10.7614 10.1353 11.4417L10.1397 11.5006C11.4544 10.5816 12.6066 9.4517 13.5478 8.15614L13.6612 8L13.5478 7.84387C12.6066 6.5483 11.4544 5.41836 10.1397 4.49941L10.1353 4.55831C10.0906 5.16553 10.0577 5.7734 10.0366 6.38157C10.0256 6.70116 9.76036 6.95458 9.43697 6.95458L8.58466 6.95458C6.26681 6.95458 4.13244 8.15534 2.94271 10.0943Z"
      fill="currentColor"
    />
  </Icon>
);
